export default __webpack_public_path__ + "static/media/community_dashboard.02a85100.svg";